module.exports = __webpack_public_path__ + "img/1546915658.9f158c12.jpg";